<div class="alert" [class]="data.type" [ngClass]="{'alert-error': data.closeButton}">
    <mat-icon>{{ data.icon }}</mat-icon>
    <span>{{ data.message }}</span>
    @if (data.closeButton) {
        <mat-icon class="close" (click)="closeSnackbar()">close</mat-icon>
    }
</div>
